<script>
    import {
        FormGroup,
        Label,
        Input
    } from "sveltestrap"

    export let autocomplete;
    export let label;
    export let name;
    export let value;
    export let placeholder = null;
    export let feedback;
</script>

<FormGroup>
    {#if label}
        <Label>{label}</Label>
    {/if}
    {#if feedback}
        <Input 
            type="text" 
            {name}
            id={name}
            {autocomplete}
            bind:value={value}
            on:change
            on:blur
            {placeholder}
            invalid
            {feedback}
        />
    {:else}
        <Input 
            type="text"
            {name}
            id={name}
            {autocomplete}
            bind:value={value}
            on:change
            on:blur
            {placeholder}
        />
    {/if}
</FormGroup>